export const version = {
  timeStamp: '2026-08-07 07:00:58 AM -03',
  version: '0.0.12-20260807070058',
}
